<template>
    <div class="text-frame">
        <h4>404 - Not found</h4>
    </div>
</template>

<script>
export default {
    name: 'NotFoundView',
    inject: ['setTitle'],
    mounted() {
        this.setTitle("Not Found")
    }
}
</script>

<style scoped>
.text-frame {
    width: 100%;
    height: calc(100vh - 64px - 80px);
    text-align: center;
}

.text-frame h4 {
    margin: 0;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
}
</style>